module.exports = __webpack_public_path__ + "img/myeasycharge-ic.b2ebe034.svg";